var getTypeScale = function getTypeScale(variant) {
  var TYPE_SCALE_PATTERN = new RegExp('(?<type>heading|body|exception)(?<size>[0-9]?[a-z]{2})(?<weight>.*)', 'i');
  var typsScaleMatch = variant.toLowerCase().match(TYPE_SCALE_PATTERN);
  return (typsScaleMatch == null ? void 0 : typsScaleMatch.groups) || {};
};

var getTypography = function getTypography(variant) {
  return function (_ref) {
    var theme = _ref.theme;
    if (typeof variant !== 'string' || !variant || !theme.typography) return '';
    var typography = theme.typography;

    var _getTypeScale = getTypeScale(variant),
        type = _getTypeScale.type,
        size = _getTypeScale.size,
        weight = _getTypeScale.weight;

    var token = type + "." + size;

    var _ref2 = typography('base') || {},
        fontFamily = _ref2.fontFamily,
        fontWeight = _ref2.fontWeight;

    var _ref3 = typography(token) || {},
        fontSize = _ref3.fontSize,
        letterSpacing = _ref3.letterSpacing,
        lineHeight = _ref3.lineHeight;

    var hasCompletelyTypeScale = fontFamily && fontSize && fontWeight[weight] && letterSpacing && lineHeight;
    return hasCompletelyTypeScale ? "\n      font-family: " + fontFamily + ";\n      font-size: " + fontSize + ";\n      font-weight: " + fontWeight[weight] + ";\n      letter-spacing: " + letterSpacing + "px;\n      line-height: " + lineHeight + ";\n    " : '';
  };
};

export { getTypography };